import React, { useRef, useState } from 'react';
import { claimsApi } from '../../firebase/functionsService';
import { useAuth } from '../../contexts/AuthContext';
import { COLORS } from '../../styles/tokens';

const fmt = n => Number(n).toLocaleString('nb-NO');
const STATUS_TEXT = {
  pending: 'Krav sendt. Tippi behandler kravet.',
  approved: 'Godkjent',
  disputed: 'Bestridt',
  rejected: 'Avvist',
};

// Sjåførens inngang til avbestillingsgebyr på et avbestilt oppdrag (bestilleren avbestilte sent).
// Serveren avgjør beløp og om kravet kan sendes; her vises bare kravet og status.
export default function CancellationFeeClaim({ order }) {
  const { currentUser } = useAuth();
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);

  const claim = (order?.claims ?? []).find(c => c.kind === 'cancellation');
  if (!claim || order.status !== 'cancelled') return null;
  if (!currentUser || order.cancelledDriverUid !== currentUser.uid) return null;

  const status = sent ? 'pending' : claim.status;

  async function submit() {
    if (inFlight.current) return;
    inFlight.current = true;
    setBusy(true);
    setError('');
    try {
      await claimsApi.submitClaim({ orderId: order.id, kind: 'cancellation' });
      setSent(true);
    } catch (err) {
      console.error('CancellationFeeClaim:', err);
      setError(err?.message || 'Noe gikk galt. Prøv igjen.');
    } finally {
      inFlight.current = false;
      setBusy(false);
    }
  }

  return (
    <div style={styles.box}>
      <div style={styles.title}>Avbestillingsgebyr</div>
      {status === 'available' ? (
        <>
          <div style={styles.info}>
            Bestiller avbestilte sent. Du kan kreve avbestillingsgebyr: {fmt(claim.amount ?? 0)} kr
          </div>
          <button type="button" style={styles.primary} disabled={busy} onClick={submit}>Krev gebyr</button>
        </>
      ) : (
        <div style={styles.info}>
          {fmt(claim.amount ?? 0)} kr: <b>{STATUS_TEXT[status] ?? status}</b>
        </div>
      )}
      {error && <p role="alert" style={styles.error}>{error}</p>}
    </div>
  );
}

const styles = {
  box:     { borderTop: `1px solid ${COLORS.border}`, padding: '11px 0', display: 'flex', flexDirection: 'column', gap: 8 },
  title:   { fontSize: 12, fontWeight: 700, color: COLORS.textLight, textTransform: 'uppercase', letterSpacing: 0.3 },
  info:    { fontSize: 14, color: COLORS.textDark },
  primary: { height: 44, borderRadius: 22, border: 'none', background: COLORS.primary, color: COLORS.onPrimary, fontWeight: 700, fontSize: 14, cursor: 'pointer', padding: '0 18px' },
  error:   { background: COLORS.dangerBg, color: COLORS.dangerText, padding: '10px 14px', borderRadius: 6, fontSize: 14, margin: 0 },
};
